export var cheatingRules = [{
  value: '1',
  content: 'Chụp khuôn mặt trước khi làm bài'
}, {
  value: '2',
  content: 'Không được chuyển tab'
}, {
  value: '3',
  content: 'Không được Copy / Paste nội dung'
}, {
  value: '4',
  content: 'Không được thoát chế độ toàn màn hình'
}, {
  value: '5',
  content: 'Bắt buộc luôn mở Camera'
}, {
  value: '6',
  content: 'Bắt buộc luôn mở Microphone'
}, {
  value: '7',
  content: 'Lưu hoạt động tiếng và hình bất thường'
}];
export var DATE_TIME_FORMAT = 'DD/MM/YYYY - HH:mm';